import React from "react";

const Quote = (
  {
    className = "",
    quote = "",
    author = "",
    position = "",
  }
) => {
  return (
    <div className={`quote ${className}`}>
      <div className="quote__text">{quote}</div>
      <div className="quote__author-wrapper">
        <div className="quote__author-name">{author}</div>
        <div className="quote__author-position">{position}</div>
      </div>
    </div>
  )
}

export default Quote
